import { render, staticRenderFns } from "./PageWorkoutLogHistory.vue?vue&type=template&id=604d769d&scoped=true"
import script from "./PageWorkoutLogHistory.vue?vue&type=script&lang=js"
export * from "./PageWorkoutLogHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604d769d",
  null
  
)

export default component.exports